(function ($, Drupal, once) {
  // eslint-disable-next-line no-param-reassign
  function closeModal(context, target) {
    target.fadeOut(500).remove();
  }

  Drupal.behaviors.directionsModalWindow = {
    attach: function (context) {
      // Intercept clicks on links that point to maps.google.com
      $('a[href*="maps.google.com"]', context).on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $link = $(this);
        var linkHref = $link.attr('href');

        $('.directions-modal-trigger', context).click();
        $('.directions-modal-target-link a', context).attr('href', linkHref);
        $('.directions-modal-target-link a', context).on('click', function (e) {
          $('.m-modal-window--generated', context).fadeOut(500).remove();
        });
        
      });
    },
  }
  ;
  // eslint-disable-next-line no-undef

})(jQuery, Drupal, once);
